/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import HotelState from '../state/HotelState'
import HotelEvent from '../../event/HotelEvent'

class HotelsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case HotelEvent.fetchAll:
        const hotels = payload.hotels.map(hotel => {
          return new HotelState(hotel)
        })
        return List(hotels)

      default:
        return state
    }
  }
}

export default new HotelsStore()
